<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="center"><a id="pv"></a> <em>For My Great-Grandmothers—</em></p>
<p class="timebreak"> <br/></p>
<p class="center"><em>Molly Mizell Donaldson</em><br/>
1875–1944, Miles, Texas</p>
<p class="timebreak"> <br/></p>
<p class="center"><em>Emma Castle Hurlburt Bettey</em><br/>
1862–1924, Walla Walla, Washington</p>
<p class="timebreak"> <br/></p>
<p class="center"><em>Nancy Kerr Lovelace</em><br/>
1853–1938, Irion County, Texas</p>
<p class="timebreak"> <br/></p>
<p class="center"><em>Lena Meyers Remlinger</em><br/>
1860–1930, Fort Vancouver, Washington</p>
<p class="timebreak"> <br/></p>
<p class="center"><em>—Westering Women, All</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?84f04d3c